import { render, staticRenderFns } from "./MedicationLog.vue?vue&type=template&id=4d15a085&scoped=true"
import script from "./MedicationLog.vue?vue&type=script&lang=js"
export * from "./MedicationLog.vue?vue&type=script&lang=js"
import style0 from "./MedicationLog.vue?vue&type=style&index=0&id=4d15a085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d15a085",
  null
  
)

export default component.exports